import { defineStore } from "pinia";
import { ref, computed } from "vue";
import ordersService from "@/services/ordersService";

export const useMeasurementStore = defineStore("measurement", () => {
  const categories = ref({});
  const measurementCategories = computed(() => categories.value);
  const importedMeasurementData = ref(null);
  const importedReportMetadata = ref(null); 
  const measurements = ref([]);

  const getMeasurementCategories = async () => {
    categories.value = { loading: true };
    try {
      const result = await ordersService.fetchMeasurementCategories();
      if (result.success) {
        categories.value = result.data.Data;
      } else {
        categories.value = { error: result.error };
      }
    } catch (error) {
      categories.value = { error };
    }
  };

  const setImportedMeasurementData = (data, metadata = null) => {
    importedMeasurementData.value = data;

    if (metadata) {
      importedReportMetadata.value = metadata;
    }
  };

  const clearMeasurements = () => {
    measurements.value = [];
    importedMeasurementData.value = null;
    importedReportMetadata.value = null;
  };

  return { categories, measurements, measurementCategories, importedMeasurementData, importedReportMetadata, getMeasurementCategories, setImportedMeasurementData, clearMeasurements };
});
